// extracted by mini-css-extract-plugin
export default {"headtop":"Home_headtop__wDyEL","h1":"Home_h1__hGLhY","p":"Home_p__bWo3p"};